import { useState } from 'react';
import { AritoFormV2, AritoIcon, BottomActionBarV2, DialogV2 } from '@/components/custom/erp';
import { AccountModel, NhapXuat, NhapXuatInput } from '@/types/schemas';
import { formSchema, FormValues, initialValues } from '../../schemas';
import { FormMode } from '@/types/form';
import Form from './FormDialog';

interface FormDialogProps {
  mode: FormMode;
  open: boolean;
  onClose: () => void;
  onSubmit?: (data: NhapXuatInput) => void;
  onAddButtonClick?: () => void;
  onEditButtonClick?: () => void;
  onDeleteButtonClick?: () => void;
  onCopyButtonClick?: () => void;
  onWatchButtonClick?: () => void;

  initialData?: NhapXuat;
}
function FormDialog({
  mode,
  open,
  onClose,
  onAddButtonClick,
  onCopyButtonClick,
  onDeleteButtonClick,
  onEditButtonClick,
  initialData,
  onSubmit
}: FormDialogProps) {
  const [account, setAccount] = useState<AccountModel | null>(initialData?.tk_data || null);

  const handleSubmit = async (data: FormValues) => {
    const formData = {
      ...data,
      tk: account?.uuid || null
    };
    onSubmit?.(formData);
  };

  return (
    <>
      <DialogV2
        open={open}
        onClose={onClose}
        title={mode === 'add' ? 'Mới' : mode === 'edit' ? 'Sửa' : 'Xem'}
        maxWidth='lg'
        disableBackdropClose={true}
        disableEscapeKeyDown={true}
        titleIcon={<AritoIcon icon={281} />}
      >
        <AritoFormV2
          mode={mode}
          hasAritoActionBar={false}
          schema={formSchema}
          onSubmit={handleSubmit}
          initialData={(initialData || initialValues) as FormValues}
          className='w-full md:min-w-[500px] lg:min-w-[600px]'
          headerFields={<Form formMode={mode} account={account} setAccount={setAccount} />}
          bottomBar={
            <BottomActionBarV2
              mode={mode}
              onAdd={onAddButtonClick}
              onEdit={onEditButtonClick}
              onDelete={onDeleteButtonClick}
              onCopy={onCopyButtonClick}
              onClose={onClose}
            />
          }
        />
      </DialogV2>
    </>
  );
}

export default FormDialog;
